import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { DiscountCodeContextProvider } from './DiscountCodeContext';
import DiscountCodeStrategy from './DiscountCodeStrategy';
import './DiscountCode.scss';

const DiscountCode = ({
  'data-qe-id': qeId,
  // discount entry props
  discountCode,
  loading,
  formattedError,
  // discount applied props
  discountApplied,
  formattedDiscountAmount,
  formattedDiscountCode,
  // handlers
  onChange,
  onApply,
  onRemove,
}) => {
  const [isInputInView, setIsInputInView] = useState(false);

  useEffect(() => {
    const discountCodeFromSearchParams = new URLSearchParams(window.location.search).get('promoCode');

    if (discountCodeFromSearchParams) {
      setIsInputInView(true);

      const trimmed = discountCodeFromSearchParams.trim();

      onChange(trimmed);
      onApply(trimmed);
    }
  }, [window.location.search]);

  return (
    <div className="discount-code-container">
      <DiscountCodeContextProvider
        value={{
          qeId,

          showInput: () => setIsInputInView(true),
          hideInput: () => setIsInputInView(false),
          toggleInput: () => setIsInputInView((prev) => !prev),

          discountCode,
          formattedError,
          loading,

          formattedDiscountAmount,
          formattedDiscountCode,

          handleChange: (event) => onChange(event.target.value.trim()),
          handleApply: () => onApply(discountCode.trim()),
          handleRemove: () => {
            onRemove();
            setIsInputInView(false);
          },
        }}
      >
        <DiscountCodeStrategy discountAppliedView={discountApplied} isInputInView={isInputInView} />
      </DiscountCodeContextProvider>
    </div>
  );
};

DiscountCode.propTypes = {
  'data-qe-id': PropTypes.string.isRequired,
  discountCode: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  formattedError: PropTypes.string,
  discountApplied: PropTypes.bool.isRequired,
  formattedDiscountAmount: PropTypes.string,
  formattedDiscountCode: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

DiscountCode.defaultProps = {
  formattedError: null,
  formattedDiscountAmount: null,
  formattedDiscountCode: null,
};

export default DiscountCode;
